import React from "react"
import { Container, Row, Col } from "reactstrap"
import { APP_NAME } from "../../config"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} ©{APP_NAME}.
            </Col>
            <Col md={6}>
              <div className="text-sm-right d-none d-sm-block">
                Design & Develop by SRV
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
